class NotAuthorizedViewModel {
    constructor() { }
}


import template from './not-authorized-page.html'
export default { viewModel : NotAuthorizedViewModel, template: template }